import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

/**
 * This is a temporary exception list which is used to determine if the link
 * is pointing to either Jira, a different instance or outside of Atlassian
 * entirely.
 */
export const isExternalLink = (url: string | undefined): boolean => {
	const windowHostname =
		typeof window !== 'undefined' && window.location
			? window.location.hostname
			: getSSRRenderInputs().host;

	// Only including support for certain Jira paths to minimise hardcoding
	const linkClickExceptionPaths = ['/browse', '/jira'];
	let urlObject: URL | undefined | '';
	try {
		// Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
		urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
	} catch {}

	const { hostname, pathname } = urlObject || {};
	return (
		(hostname && windowHostname && hostname !== windowHostname) ||
		linkClickExceptionPaths.some((exceptionPath) => pathname?.startsWith(exceptionPath))
	);
};
